export default __webpack_public_path__ + "static/media/fossil5.445329ad.png";